"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationName = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var LocationName;
(function (LocationName) {
    LocationName["OneTwoSixDotCom"] = "126.com";
    LocationName["OneSixThreeDotCom"] = "163.com";
    LocationName["AmazonDrive"] = "Amazon Drive";
    LocationName["Aol"] = "AOL";
    LocationName["Bitbucket"] = "Bitbucket";
    LocationName["Box"] = "Box";
    LocationName["BoxDrive"] = "Box Drive";
    LocationName["Comcast"] = "Comcast";
    LocationName["DeviceName"] = "Device Name";
    LocationName["Dropbox"] = "Dropbox";
    LocationName["Facebook"] = "Facebook";
    LocationName["FacebookMessenger"] = "Facebook Messenger";
    LocationName["Github"] = "GitHub";
    LocationName["Gitlab"] = "GitLab";
    LocationName["Gmail"] = "Gmail";
    LocationName["GoogleDrive"] = "Google Drive";
    LocationName["Icloud"] = "iCloud";
    LocationName["Linkedin"] = "LinkedIn";
    LocationName["MailDotCom"] = "mail.com";
    LocationName["Mega"] = "Mega";
    LocationName["MicrosoftTeams"] = "Microsoft Teams";
    LocationName["MultiplePossibilities"] = "Multiple Possibilities";
    LocationName["Onedrive"] = "OneDrive";
    LocationName["Outlook"] = "Outlook";
    LocationName["Protonmail"] = "ProtonMail";
    LocationName["Qq"] = "QQ";
    LocationName["Reddit"] = "Reddit";
    LocationName["SinaMail"] = "Sina Mail";
    LocationName["Slack"] = "Slack";
    LocationName["SohuMail"] = "Sohu Mail";
    LocationName["Sourceforge"] = "SourceForge";
    LocationName["Twitter"] = "Twitter";
    LocationName["Uncategorized"] = "Uncategorized";
    LocationName["Whatsapp"] = "WhatsApp";
    LocationName["Yahoo"] = "Yahoo";
    LocationName["Zoho"] = "Zoho";
    LocationName["Unknown"] = "Unknown";
    LocationName["UnmonitoredDevice"] = "Unmonitored Device";
    LocationName["FourChan"] = "4chan";
    LocationName["AcrobatSign"] = "Acrobat Sign";
    LocationName["Adobe"] = "Adobe";
    LocationName["AdobeAcrobat"] = "Adobe Acrobat";
    LocationName["AdobeWorkfront"] = "Adobe Workfront";
    LocationName["Adp"] = "ADP";
    LocationName["AdpReporting"] = "ADP Reporting";
    LocationName["Aetna"] = "Aetna";
    LocationName["Agiloft"] = "Agiloft";
    LocationName["Aha"] = "Aha!";
    LocationName["Airbnb"] = "Airbnb";
    LocationName["Airtable"] = "Airtable";
    LocationName["Alibaba"] = "Alibaba";
    LocationName["Amazon"] = "Amazon";
    LocationName["AmazonPhotos"] = "Amazon Photos";
    LocationName["AmazonWebServices"] = "Amazon Web Services";
    LocationName["AmazonJobs"] = "Amazon Jobs";
    LocationName["Anaplan"] = "Anaplan";
    LocationName["Anthem"] = "Anthem";
    LocationName["Appfolio"] = "AppFolio";
    LocationName["Apptus"] = "Apptus";
    LocationName["Articulate"] = "Articulate";
    LocationName["Asana"] = "Asana";
    LocationName["Askfm"] = "Askfm";
    LocationName["Aspose"] = "Aspose";
    LocationName["Auditboard"] = "AuditBoard";
    LocationName["Autodesk"] = "Autodesk";
    LocationName["Avery"] = "Avery";
    LocationName["Azure"] = "Azure";
    LocationName["BaiduNetdisk"] = "Baidu NetDisk";
    LocationName["Bamboohr"] = "BambooHR";
    LocationName["BankOfAmerica"] = "Bank of America";
    LocationName["Basecamp"] = "Basecamp";
    LocationName["Befunky"] = "BeFunky";
    LocationName["Benchling"] = "Benchling";
    LocationName["Bizzabo"] = "Bizzabo";
    LocationName["Bizzflo"] = "Bizzflo";
    LocationName["Blackline"] = "BlackLine";
    LocationName["Blogger"] = "Blogger";
    LocationName["Bynder"] = "Bynder";
    LocationName["CareersPage"] = "Careers Page";
    LocationName["Canva"] = "Canva";
    LocationName["Carvana"] = "Carvana";
    LocationName["Chase"] = "Chase";
    LocationName["Cigna"] = "Cigna";
    LocationName["Cisco"] = "Cisco";
    LocationName["Clideo"] = "Clideo";
    LocationName["Clientaxcess"] = "ClientAxcess";
    LocationName["Cloudconvert"] = "CloudConvert";
    LocationName["Code42"] = "Code42";
    LocationName["Colaboratory"] = "Colaboratory";
    LocationName["Combinepdf"] = "CombinePDF";
    LocationName["CompressJpeg"] = "Compress JPEG";
    LocationName["Concur"] = "Concur";
    LocationName["Confluence"] = "Confluence";
    LocationName["Conga"] = "Conga";
    LocationName["ConstantContact"] = "Constant Contact";
    LocationName["ConsumerfundingSolutions"] = "Consumerfunding Solutions";
    LocationName["Cornerstone"] = "Cornerstone";
    LocationName["CostcoPhotoCenter"] = "Costco Photo Center";
    LocationName["Coupa"] = "Coupa";
    LocationName["Craigslist"] = "Craigslist";
    LocationName["Crashplan"] = "Crashplan";
    LocationName["Crowdstrike"] = "CrowdStrike";
    LocationName["Cvent"] = "Cvent";
    LocationName["Cvs"] = "CVS";
    LocationName["DataloaderDotIo"] = "dataloader.io";
    LocationName["Dayforce"] = "Dayforce";
    LocationName["DelhiAirport"] = "Delhi Airport";
    LocationName["Deloitte"] = "Deloitte";
    LocationName["Delta"] = "Delta";
    LocationName["DeviantArt"] = "DeviantArt";
    LocationName["DiagramsDotNet"] = "diagrams.net";
    LocationName["Diligent"] = "Diligent";
    LocationName["Discord"] = "Discord";
    LocationName["Docusign"] = "Docusign";
    LocationName["Domo"] = "Domo";
    LocationName["DrakePortals"] = "Drake Portals";
    LocationName["Dundas"] = "Dundas";
    LocationName["Ebay"] = "eBay";
    LocationName["Egnyte"] = "Egnyte";
    LocationName["Etrade"] = "E-Trade";
    LocationName["Etsy"] = "Etsy";
    LocationName["Evernote"] = "Evernote";
    LocationName["Expensify"] = "Expensify";
    LocationName["Ey"] = "EY";
    LocationName["Ezgif"] = "EZgif";
    LocationName["Fastmail"] = "Fastmail";
    LocationName["Fedex"] = "FedEx";
    LocationName["FidelityDotCom"] = "Fidelity.com";
    LocationName["Figma"] = "Figma";
    LocationName["FileDotIo"] = "File.io";
    LocationName["Filestack"] = "Filestack";
    LocationName["Fiverr"] = "Fiverr";
    LocationName["Flickr"] = "Flickr";
    LocationName["Flixster"] = "Flixster";
    LocationName["Floqast"] = "FloQast";
    LocationName["Fragomen"] = "Fragomen";
    LocationName["FrameDotIo"] = "Frame.io";
    LocationName["FreeConvert"] = "Free Convert";
    LocationName["FreePdfConvert"] = "Free PDF Convert";
    LocationName["GithubPages"] = "GitHub Pages";
    LocationName["Gmx"] = "GMX";
    LocationName["Google"] = "Google";
    LocationName["GoogleAds"] = "Google Ads";
    LocationName["GoogleAnalytics"] = "Google Analytics";
    LocationName["GoogleAppsScript"] = "Google Apps Script";
    LocationName["GoogleBusinessProfile"] = "Google Business Profile";
    LocationName["GoogleCalendar"] = "Google Calendar";
    LocationName["GoogleChat"] = "Google Chat";
    LocationName["GoogleChrome"] = "Google Chrome";
    LocationName["GoogleClassroom"] = "Google Classroom";
    LocationName["GoogleCloudConsole"] = "Google Cloud Console";
    LocationName["GoogleCloudShell"] = "Google Cloud Shell";
    LocationName["GoogleDataStudio"] = "Google Data Studio";
    LocationName["GoogleDv360"] = "Google DV360";
    LocationName["GoogleHangouts"] = "Google Hangouts";
    LocationName["GoogleJamboard"] = "Google Jamboard";
    LocationName["GoogleKeep"] = "Google Keep";
    LocationName["GoogleLooker"] = "Google Looker";
    LocationName["GoogleMeet"] = "Google Meet";
    LocationName["GoogleMessages"] = "Google Messages";
    LocationName["GooglePhotos"] = "Google Photos";
    LocationName["GoogleRemoteDesktop"] = "Google Remote Desktop";
    LocationName["GoogleSearch"] = "Google Search";
    LocationName["GoogleSites"] = "Google Sites";
    LocationName["GoogleTagManager"] = "Google Tag Manager";
    LocationName["GoogleTranslate"] = "Google Translate";
    LocationName["GoogleVault"] = "Google Vault";
    LocationName["GoogleVoice"] = "Google Voice";
    LocationName["GoogleWorkspace"] = "Google Workspace";
    LocationName["GovernmentSite"] = "Government Site";
    LocationName["Greenhouse"] = "Greenhouse";
    LocationName["Groupgreeting"] = "GroupGreeting";
    LocationName["GuaranteedRate"] = "Guaranteed Rate";
    LocationName["HrBlock"] = "H&R Block";
    LocationName["Handshake"] = "Handshake";
    LocationName["Healthequity"] = "HealthEquity";
    LocationName["Heictojpeg"] = "HEICtoJPEG";
    LocationName["Hellosign"] = "HelloSign";
    LocationName["Highbond"] = "HighBond";
    LocationName["Highspot"] = "Highspot";
    LocationName["Hireright"] = "HireRight";
    LocationName["Hopin"] = "Hopin";
    LocationName["Hubspot"] = "HubSpot";
    LocationName["Icims"] = "iCIMS";
    LocationName["Idrive"] = "iDrive";
    LocationName["Iloveimg"] = "iLoveIMG";
    LocationName["Ilovepdf"] = "iLovePDF";
    LocationName["IdDotMe"] = "ID.me";
    LocationName["ImageColorPicker"] = "Image Color Picker";
    LocationName["Imgflip"] = "Imgflip";
    LocationName["Imgur"] = "Imgur";
    LocationName["Indeed"] = "Indeed";
    LocationName["Instagram"] = "Instagram";
    LocationName["Instructure"] = "Instructure";
    LocationName["Inszoom"] = "INSZoom";
    LocationName["Intacct"] = "Intacct";
    LocationName["Intuit"] = "Intuit";
    LocationName["Ironclad"] = "IronClad";
    LocationName["Jazzhr"] = "JazzHR";
    LocationName["Jenkins"] = "Jenkins";
    LocationName["Jira"] = "Jira";
    LocationName["Jobvite"] = "Jobvite";
    LocationName["Jotform"] = "Jotform";
    LocationName["Jpg2Pdf"] = "JPG2PDF";
    LocationName["Kahoot"] = "Kahoot";
    LocationName["KaiserPermanente"] = "Kaiser Permanente";
    LocationName["Kapwing"] = "Kapwing";
    LocationName["Kijiji"] = "Kijiji";
    LocationName["Kudoboard"] = "Kudoboard";
    LocationName["Lever"] = "Lever";
    LocationName["LinkedinJobs"] = "LinkedIn Jobs";
    LocationName["Lucid"] = "Lucid";
    LocationName["Lycos"] = "Lycos";
    LocationName["Manulife"] = "Manulife";
    LocationName["Marketo"] = "Marketo";
    LocationName["Medium"] = "Medium";
    LocationName["Meetup"] = "Meetup";
    LocationName["MetaCareers"] = "Meta Careers";
    LocationName["Microsoft"] = "Microsoft";
    LocationName["MicrosoftDynamics365"] = "Microsoft Dynamics 365";
    LocationName["MicrosoftPowerApps"] = "Microsoft Power Apps";
    LocationName["MicrosoftBing"] = "Microsoft Bing";
    LocationName["MicrosoftCareers"] = "Microsoft Careers";
    LocationName["MicrosoftDocs"] = "Microsoft Docs";
    LocationName["MicrosoftEndpointManager"] = "Microsoft Endpoint Manager";
    LocationName["MicrosoftPlanner"] = "Microsoft Planner";
    LocationName["MicrosoftPowerbi"] = "Microsoft PowerBI";
    LocationName["MicrosoftStream"] = "Microsoft Stream";
    LocationName["Miro"] = "Miro";
    LocationName["Mix"] = "Mix";
    LocationName["Monday"] = "Monday";
    LocationName["Mpix"] = "Mpix";
    LocationName["Mulesoft"] = "Mulesoft";
    LocationName["Mural"] = "Mural";
    LocationName["MyOracleSupport"] = "My Oracle Support";
    LocationName["Myfonts"] = "MyFonts";
    LocationName["NationwidePetInsurance"] = "Nationwide Pet Insurance";
    LocationName["NaukriDotCom"] = "Naukri.com";
    LocationName["Naver"] = "NAVER";
    LocationName["Navia"] = "Navia";
    LocationName["Nextdoor"] = "Nextdoor";
    LocationName["Notion"] = "Notion";
    LocationName["Odnoklassniki"] = "Odnoklassniki";
    LocationName["Ok"] = "OK";
    LocationName["Okta"] = "Okta";
    LocationName["OmadaHealth"] = "Omada Health";
    LocationName["Onetrust"] = "OneTrust";
    LocationName["Onvio"] = "Onvio";
    LocationName["OpentextCloud"] = "OpenText Cloud";
    LocationName["OpentextDocumentum"] = "OpenText Documentum";
    LocationName["OpentextHightail"] = "OpenText Hightail";
    LocationName["OptumFinancial"] = "Optum Financial";
    LocationName["Oracle"] = "Oracle";
    LocationName["OracleHumanResourcesCloud"] = "Oracle Human Resources Cloud";
    LocationName["OraclePeoplesoft"] = "Oracle PeopleSoft";
    LocationName["OracleTaleo"] = "Oracle Taleo";
    LocationName["OracleNetsuite"] = "Oracle NetSuite";
    LocationName["Overleaf"] = "Overleaf";
    LocationName["Paypal"] = "PayPal";
    LocationName["Pdf24Tools"] = "PDF24 Tools";
    LocationName["Pdfescape"] = "PDFescape";
    LocationName["Pdffiller"] = "pdfFiller";
    LocationName["Pdfsimpli"] = "PDFSimpli";
    LocationName["Performyard"] = "PerformYard";
    LocationName["Photopea"] = "Photopea";
    LocationName["Pinterest"] = "Pinterest";
    LocationName["Pixlr"] = "Pixlr";
    LocationName["Poshmark"] = "Poshmark";
    LocationName["Procore"] = "Procore";
    LocationName["Pwc"] = "PwC";
    LocationName["Qlik"] = "Qlik";
    LocationName["Qualtrics"] = "Qualtrics";
    LocationName["Quip"] = "Quip";
    LocationName["Qzone"] = "Qzone";
    LocationName["RemoveDotBg"] = "remove.bg";
    LocationName["Rentcafe"] = "RentCafe";
    LocationName["Reverbnation"] = "ReverbNation";
    LocationName["Ryanair"] = "Ryanair";
    LocationName["Salesforce"] = "Salesforce";
    LocationName["SalesforceDevelopment"] = "Salesforce Development";
    LocationName["Salesloft"] = "Salesloft";
    LocationName["SapServiceCloud"] = "SAP Service Cloud";
    LocationName["SapAriba"] = "SAP Ariba";
    LocationName["SapBusinessObjects"] = "SAP Business Objects";
    LocationName["SapFieldglass"] = "SAP Fieldglass";
    LocationName["SapLitmos"] = "SAP Litmos";
    LocationName["SapSuccessfactors"] = "SAP SuccessFactors";
    LocationName["SecureFirmPortal"] = "Secure Firm Portal";
    LocationName["SecureNetlinkSolution"] = "Secure Netlink Solution";
    LocationName["Sejda"] = "Sejda";
    LocationName["Servicenow"] = "ServiceNow";
    LocationName["Sharefile"] = "Sharefile";
    LocationName["Shareworks"] = "Shareworks";
    LocationName["Shutterfly"] = "Shutterfly";
    LocationName["Smallpdf"] = "SmallPDF";
    LocationName["Smartrecruiters"] = "SmartRecruiters";
    LocationName["Smartsheet"] = "Smartsheet";
    LocationName["Smartvault"] = "SmartVault";
    LocationName["Snapfish"] = "Snapfish";
    LocationName["Snowflake"] = "Snowflake";
    LocationName["SodaPdf"] = "Soda PDF";
    LocationName["Spideroak"] = "SpiderOak";
    LocationName["Splunk"] = "Splunk";
    LocationName["Springcm"] = "SpringCM";
    LocationName["SproutSocial"] = "Sprout Social";
    LocationName["StackOverflow"] = "Stack Overflow";
    LocationName["Staples"] = "Staples";
    LocationName["StrategicSourcing"] = "Strategic Sourcing";
    LocationName["Strava"] = "Strava";
    LocationName["Sugarsync"] = "SugarSync";
    LocationName["Surveymonkey"] = "SurveyMonkey";
    LocationName["Tableau"] = "Tableau";
    LocationName["Tagged"] = "Tagged";
    LocationName["Taxcaddy"] = "TaxCaddy";
    LocationName["Telegram"] = "Telegram";
    LocationName["TheKnot"] = "The Knot";
    LocationName["Tinypng"] = "TinyPNG";
    LocationName["Treering"] = "TreeRing";
    LocationName["Trello"] = "Trello";
    LocationName["Tripactions"] = "TripActions";
    LocationName["Tumblr"] = "Tumblr";
    LocationName["Turbotax"] = "TurboTax";
    LocationName["Turo"] = "Turo";
    LocationName["Tutanota"] = "Tutanota";
    LocationName["Twitch"] = "Twitch";
    LocationName["Typeform"] = "Typeform";
    LocationName["Ud"] = "UD";
    LocationName["Uniflow"] = "uniFLOW";
    LocationName["UnitedAirlines"] = "United Airlines";
    LocationName["Ups"] = "UPS";
    LocationName["Upwork"] = "Upwork";
    LocationName["Usaa"] = "USAA";
    LocationName["Veed"] = "VEED";
    LocationName["VeevaVault"] = "Veeva Vault";
    LocationName["Vimeo"] = "Vimeo";
    LocationName["Vistaprint"] = "VistaPrint";
    LocationName["VisualStudio"] = "Visual Studio";
    LocationName["Vk"] = "Vk";
    LocationName["VspVisioncare"] = "VSP Visioncare";
    LocationName["Wageworks"] = "WageWorks";
    LocationName["Walgreens"] = "Walgreens";
    LocationName["WalmartPhoto"] = "Walmart Photo";
    LocationName["Webex"] = "Webex";
    LocationName["Wechat"] = "WeChat";
    LocationName["Weibo"] = "Weibo";
    LocationName["WellsFargo"] = "Wells Fargo";
    LocationName["Wetransfer"] = "WeTransfer";
    LocationName["Wex"] = "WEX";
    LocationName["Wix"] = "Wix";
    LocationName["Wordpress"] = "WordPress";
    LocationName["Workable"] = "Workable";
    LocationName["Workday"] = "Workday";
    LocationName["Workiva"] = "Workiva";
    LocationName["Wrike"] = "Wrike";
    LocationName["Xactly"] = "Xactly";
    LocationName["Yourcause"] = "YourCause";
    LocationName["Youtube"] = "YouTube";
    LocationName["Zazzle"] = "Zazzle";
    LocationName["Zendesk"] = "Zendesk";
    LocationName["Zillow"] = "Zillow";
    LocationName["Zix"] = "Zix";
    LocationName["Zola"] = "Zola";
    LocationName["Zoom"] = "Zoom";
    LocationName["GitlabPages"] = "GitLab Pages";
    LocationName["Moodle"] = "moodle";
    LocationName["OracleAnalytics"] = "Oracle Analytics";
    LocationName["OracleFscm"] = "Oracle FSCM";
    LocationName["Sap"] = "SAP";
    LocationName["AdobeStock"] = "Adobe Stock";
    LocationName["OfficeDepot"] = "Office Depot";
    LocationName["WorkdayAdaptivePlanning"] = "Workday Adaptive Planning";
    LocationName["WorkdayCareers"] = "Workday Careers";
    LocationName["OtherCodeRepository"] = "Other Code Repository";
    LocationName["RemovableMedia"] = "Removable Media";
    LocationName["Allscripts"] = "Allscripts";
    LocationName["Apache"] = "Apache";
    LocationName["AppDynamics"] = "AppDynamics";
    LocationName["ArtifactUprising"] = "Artifact Uprising";
    LocationName["AtAndT"] = "AT&T";
    LocationName["AthenaHealth"] = "Athena Health";
    LocationName["AwsTraining"] = "AWS Training";
    LocationName["AzureDevops"] = "Azure DevOps";
    LocationName["BeyondCompare"] = "Beyond Compare";
    LocationName["BraveBrowser"] = "Brave Browser";
    LocationName["Buildingconnected"] = "BuildingConnected";
    LocationName["Carecloud"] = "Carecloud";
    LocationName["ChangeHealthcare"] = "Change Healthcare";
    LocationName["Chromeriver"] = "Chromeriver";
    LocationName["ConvertCsv"] = "Convert CSV";
    LocationName["Convertio"] = "Convertio";
    LocationName["Cpsi"] = "CPSI";
    LocationName["Curl"] = "Curl";
    LocationName["CustomInk"] = "Custom Ink";
    LocationName["Cyberduck"] = "Cyberduck";
    LocationName["Datasite"] = "Datasite";
    LocationName["Degoo"] = "Degoo";
    LocationName["Dochub"] = "DocHub";
    LocationName["EclinicalWorks"] = "Eclinical Works";
    LocationName["Eclipse"] = "Eclipse";
    LocationName["Elastic"] = "Elastic";
    LocationName["Epic"] = "Epic";
    LocationName["Ezyzip"] = "ezyZip";
    LocationName["Filezilla"] = "Filezilla";
    LocationName["Flutter"] = "Flutter";
    LocationName["Forma"] = "Forma";
    LocationName["Glassdoor"] = "Glassdoor";
    LocationName["Gofile"] = "Gofile";
    LocationName["Gradle"] = "Gradle";
    LocationName["GrantThornton"] = "Grant Thornton";
    LocationName["HboMax"] = "HBO Max";
    LocationName["HealthCatalyst"] = "Health Catalyst";
    LocationName["Hudl"] = "Hudl";
    LocationName["Ibm"] = "IBM";
    LocationName["IbmCloud"] = "IBM Cloud";
    LocationName["Imessage"] = "iMessage";
    LocationName["Intel"] = "Intel";
    LocationName["Intralinks"] = "Intralinks";
    LocationName["Iterm2"] = "iTerm2";
    LocationName["Jaggaer"] = "Jaggaer";
    LocationName["JobScore"] = "Job Score";
    LocationName["Logitech"] = "Logitech";
    LocationName["Marriott"] = "Marriott";
    LocationName["Medhost"] = "Medhost";
    LocationName["MediAssist"] = "Medi Assist";
    LocationName["Meditech"] = "Meditech";
    LocationName["MicrosoftAppcenter"] = "Microsoft Appcenter";
    LocationName["MicrosoftEdge"] = "Microsoft Edge";
    LocationName["MixbookPhotoCo"] = "Mixbook Photo Co.";
    LocationName["MozillaFirefox"] = "Mozilla Firefox";
    LocationName["MyCloud"] = "My Cloud";
    LocationName["Netflix"] = "Netflix";
    LocationName["NodeDotJs"] = "Node.js";
    LocationName["OnespanSign"] = "OneSpan Sign";
    LocationName["Online2Pdf"] = "Online2PDF";
    LocationName["OnlineConverter"] = "Online Converter";
    LocationName["Openpdf"] = "OpenPDF";
    LocationName["Optus"] = "Optus";
    LocationName["OracleCerner"] = "Oracle Cerner";
    LocationName["OracleCernerEmr"] = "Oracle Cerner - EMR";
    LocationName["OracleJdk"] = "Oracle JDK";
    LocationName["Pcloud"] = "pCloud";
    LocationName["PdfCompressor"] = "PDF Compressor";
    LocationName["PdfOnline"] = "PDF Online";
    LocationName["Pdf2Go"] = "PDF2GO";
    LocationName["Pdf2Jpg"] = "PDF2JPG";
    LocationName["Png2Pdf"] = "PNG2PDF";
    LocationName["Postman"] = "Postman";
    LocationName["Rescue"] = "Rescue";
    LocationName["Scp"] = "SCP";
    LocationName["Sftp"] = "SFTP";
    LocationName["Smugmug"] = "SmugMug";
    LocationName["Sourcetree"] = "Sourcetree";
    LocationName["SparkNewZealand"] = "Spark New Zealand";
    LocationName["Spotify"] = "Spotify";
    LocationName["TataConsultancyServices"] = "Tata Consultancy Services";
    LocationName["Telstra"] = "Telstra";
    LocationName["TheTradeDesk"] = "The Trade Desk";
    LocationName["Tiktok"] = "TikTok";
    LocationName["Tmobile"] = "TMobile";
    LocationName["Travelers"] = "Travelers";
    LocationName["Ukg"] = "UKG";
    LocationName["Verizon"] = "Verizon";
    LocationName["Viber"] = "Viber";
    LocationName["Vrbo"] = "VRBO";
    LocationName["Workhuman"] = "Workhuman";
    LocationName["Xtramail"] = "XtraMail";
    LocationName["Yammer"] = "Yammer";
    LocationName["OneTwoThreeAppsVideoCutter"] = "123Apps Video Cutter";
    LocationName["AmazonS3"] = "Amazon S3";
    LocationName["AmericanExpress"] = "American Express";
    LocationName["AndroidDevelopers"] = "Android Developers";
    LocationName["Apple"] = "Apple";
    LocationName["AzureRepos"] = "Azure Repos";
    LocationName["BillDotCom"] = "Bill.com";
    LocationName["Bloomberg"] = "Bloomberg";
    LocationName["Brandfolder"] = "Brandfolder";
    LocationName["Brassring"] = "BrassRing";
    LocationName["Chatgpt"] = "ChatGPT";
    LocationName["Clipchamp"] = "Clipchamp";
    LocationName["CodeBeautify"] = "Code Beautify";
    LocationName["Contentful"] = "Contentful";
    LocationName["Datadog"] = "Datadog";
    LocationName["Dbeaver"] = "DBeaver";
    LocationName["Dhl"] = "DHL";
    LocationName["DlpTest"] = "DLP Test";
    LocationName["DropboxDocsend"] = "Dropbox DocSend";
    LocationName["EnvatoElements"] = "Envato Elements";
    LocationName["Envoy"] = "Envoy";
    LocationName["Fotor"] = "Fotor";
    LocationName["HdfcBank"] = "HDFC Bank";
    LocationName["IciciBank"] = "ICICI Bank";
    LocationName["InternetArchive"] = "Internet Archive";
    LocationName["Jetbrains"] = "JetBrains";
    LocationName["Lenovo"] = "Lenovo";
    LocationName["Lg"] = "LG";
    LocationName["Mysql"] = "MySQL";
    LocationName["NotepadPlusPlus"] = "Notepad++";
    LocationName["ObsStudio"] = "OBS Studio";
    LocationName["PdfJoiner"] = "PDF Joiner";
    LocationName["Photobox"] = "Photobox";
    LocationName["Python"] = "Python";
    LocationName["Reduceimages"] = "ReduceImages";
    LocationName["Softonic"] = "Softonic";
    LocationName["Squarespace"] = "Squarespace";
    LocationName["SublimeText"] = "Sublime Text";
    LocationName["Thingiverse"] = "Thingiverse";
    LocationName["Tinyjpg"] = "TinyJPG";
    LocationName["Udemy"] = "Udemy";
    LocationName["Vmware"] = "VMware";
    LocationName["Wikipedia"] = "Wikipedia";
    LocationName["Xodo"] = "Xodo";
    LocationName["YahooSearch"] = "Yahoo Search";
    LocationName["Zerodha"] = "Zerodha";
    LocationName["NetworkStorageName"] = "Network Storage Name";
    LocationName["AragonDotAi"] = "Aragon.ai";
    LocationName["BlackboxDotAi"] = "Blackbox.ai";
    LocationName["ClaudeDotAi"] = "Claude.ai";
    LocationName["CopyDotAi"] = "Copy.ai";
    LocationName["GithubCopilot"] = "GitHub Copilot";
    LocationName["GoogleGemini"] = "Google Gemini";
    LocationName["HotpotDotAi"] = "Hotpot.ai";
    LocationName["JasperDotAi"] = "Jasper.ai";
    LocationName["KreaDotAi"] = "Krea.ai";
    LocationName["LlamaindexDotAi"] = "Llamaindex.ai";
    LocationName["NottaDotAi"] = "Notta.ai";
    LocationName["OtterDotAi"] = "Otter.ai";
    LocationName["PerplexityDotAi"] = "Perplexity.ai";
    LocationName["VizcomDotAi"] = "Vizcom.ai";
})(LocationName = exports.LocationName || (exports.LocationName = {}));
